import { jsx as _jsx } from "react/jsx-runtime";
export const Card = ({ children, className = '' }) => {
    return (_jsx("div", { className: `bg-white dark:bg-slate-800 rounded-lg shadow-md overflow-hidden ${className}`, children: children }));
};
export const CardHeader = ({ children, className = '' }) => {
    return (_jsx("div", { className: `p-4 border-b border-slate-200 dark:border-slate-700 ${className}`, children: children }));
};
export const CardTitle = ({ children, className = '' }) => {
    return (_jsx("h3", { className: `text-lg font-semibold text-slate-900 dark:text-slate-50 ${className}`, children: children }));
};
export const CardContent = ({ children, className = '' }) => {
    return (_jsx("div", { className: `p-4 ${className}`, children: children }));
};
